import { C, fonts } from "../theme.js";
import { SectionLabel } from "./primitives.jsx";
import { STATS } from "../content.js";

export const About = ({ accent }) => (
  <section id="about" style={{ background: C.about, padding: "140px 40px" }}>
    <div
      className="about-grid"
      style={{
        maxWidth: 1280,
        margin: "0 auto",
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: 80,
        alignItems: "start",
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: 22 }}>
        <SectionLabel accent={accent}>// PUNTA TECH</SectionLabel>
        <h2
          style={{
            margin: 0,
            fontFamily: fonts.serif,
            fontSize: "clamp(40px, 5.4vw, 72px)",
            fontWeight: 500,
            color: C.fg,
            lineHeight: 1.0,
            letterSpacing: "-0.01em",
          }}
        >
          Engineering<br />at the{" "}
          <em style={{ color: accent, fontStyle: "italic", fontWeight: 500 }}>frontier.</em>
        </h2>
        <p
          style={{
            margin: 0,
            fontFamily: fonts.sans,
            fontSize: 16,
            lineHeight: 1.7,
            color: C.body,
            maxWidth: 520,
          }}
        >
          Punta Tech is a specialized AI and data engineering firm based in Madrid, operating globally. Our team has shipped production ML systems at scale for companies in insurance, gaming, and enterprise software.
        </p>
        <p
          style={{
            margin: 0,
            fontFamily: fonts.serif,
            fontSize: 22,
            fontStyle: "italic",
            color: C.fg,
            fontWeight: 400,
            lineHeight: 1.4,
            maxWidth: 520,
            marginTop: 4,
          }}
        >
          We don't consult from the sidelines — we build alongside you.
        </p>
      </div>
      <div style={{ display: "flex", flexDirection: "column" }}>
        {STATS.map(([n, l], i) => (
          <div
            key={i}
            style={{
              display: "grid",
              gridTemplateColumns: "minmax(120px, 160px) 1fr auto",
              alignItems: "baseline",
              gap: 24,
              padding: "26px 0",
              borderBottom: i === STATS.length - 1 ? "none" : `1px solid ${C.border}`,
              borderTop: i === 0 ? `1px solid ${C.border}` : "none",
            }}
          >
            <div
              style={{
                fontFamily: fonts.serif,
                fontSize: 64,
                fontWeight: 500,
                color: accent,
                lineHeight: 1,
                letterSpacing: "-0.02em",
              }}
            >
              {n}
            </div>
            <div style={{ fontFamily: fonts.sans, fontSize: 15, color: C.fg, letterSpacing: "0.005em" }}>
              {l}
            </div>
            <div style={{ fontFamily: fonts.mono, fontSize: 11, color: C.faint, letterSpacing: "0.18em" }}>
              0{i + 1}
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
